import { StarIcon } from "@heroicons/react/20/solid";

export type TestimonialProps = {
  title?: string;
  icon?: any;
  quote: string | string[];
  author: string;
  bgClass?: string;
};

const TestimonialSlide = (props: TestimonialProps) => {
  const icons = [...Array(5)];
  return (
    // width done in a bit hacky way, will update later...
    // max-w-[20rem]
    <div className="flex h-full min-h-[18rem] min-w-[14rem] max-w-full flex-col rounded-xl border-2 border-green bg-white p-6">
      <h5 className="text-lg font-bold text-purpleblue md:text-xl 2xl:text-2xl">
        {props.title}
      </h5>
      <div className="mb-4 flex">
        {icons.map((icon, i) => (
          <StarIcon key={i} className="h-5 fill-orange" />
        ))}
      </div>
      <p className="mb-12 text-sm/5 italic text-grey-65 md:mb-2 md:text-base/5">{`"${props.quote}"`}</p>
      <p className="mt-auto text-sm font-bold text-grey-85">{props.author}</p>
    </div>
  );
};

export default TestimonialSlide;
